import React from 'react';

import { CustomButton, CustomSelect, CustomTextarea, VideoUpload } from '../../../../components';
import { infractionTypeOptions } from '../../../../types/navigationTips';

interface EditFormProps {
    form: {
        infractionType: string;
        description: string;
        text: string;
        videoLink: string;
    };
    onFormChange: (field: string, value: any) => void;
    onFileSelected: (file: File | null) => void;
    onBack: () => void;
    onSubmit: () => void;
    mode: 'create' | 'edit';
}

const EditForm: React.FC<EditFormProps> = ({
    form,
    onFormChange,
    onFileSelected,
    onBack,
    onSubmit,
    mode
}) => {
    return (
        <div className="padding-20">
            <div className="margin-bottom-10 margin-x-10">
                <CustomSelect
                    label="Tipo de Infração *"
                    id="navigation-tip-type"
                    value={form.infractionType}
                    onChange={(v: string) => onFormChange('infractionType', v)}
                    options={infractionTypeOptions.slice(1)}
                />
            </div>

            <div className="margin-bottom-10 margin-x-10">
                <CustomTextarea
                    label="Descrição *"
                    id="navigation-tip-description"
                    value={form.description}
                    onChange={(v: string) => onFormChange('description', v)}
                    rows={2}
                    placeholder="Digite a descrição do tipo de infração..."
                />
            </div>

            <div className="margin-bottom-10 margin-right-10">
                <CustomTextarea
                    label="Texto *"
                    id="navigation-tip-text"
                    value={form.text}
                    onChange={(v: string) => onFormChange('text', v)}
                    rows={4}
                    placeholder="Digite o texto da dica de navegação..."
                />
            </div>

            <div className="margin-bottom-10 margin-x-10">
                <VideoUpload
                    currentVideoUrl={form.videoLink}
                    onVideoUploaded={(videoUrl: string) => onFormChange('videoLink', videoUrl)}
                    onFileSelected={onFileSelected}
                    disabled={false}
                />
            </div>

            <div className="display-flex justify-content-end gap-2 margin-top-20">
                <CustomButton
                    variant="outline"
                    onClick={onBack}
                    className="margin-right-10"
                >
                    Cancelar
                </CustomButton>
                <CustomButton
                    variant="primary"
                    onClick={onSubmit}
                >
                    Salvar
                </CustomButton>
            </div>
        </div>
    );
};

export default EditForm; 